import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { DialogService } from 'src/app/shared/services/dialog.service';

interface pregunta {
  pregunta: string,
  imagen: string,
  opciones: opcion[],
  correctas: number[],
}

interface opcion {
  numero: number,
  texto: string,
}

@Component({
  selector: 'editar-curso-examen',
  templateUrl: './editar-curso-examen.component.html',
  styleUrls: ['./editar-curso-examen.component.css']
})
export class EditarCursoExamenComponent implements OnInit {

  constructor(
    private storage: AngularFireStorage,
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private dialogService: DialogService,
  ) { }

  id = this.route.snapshot.paramMap.get('id');

  examen: pregunta[] = [];

  // Variables auxilires para guardar imagen

  downloadURL: any;
  fire: any;

  ngOnInit(): void {
    this.cargarExamen()
  }

  cargarExamen() {
    this.afs.collection("examen").doc(this.id).ref.get().then((doc) => {
      if (doc.exists) {
        this.examen = doc.data()['preguntas'] as pregunta[];
      }
    }).catch(error => {
      console.log(error);
    })
  }

  anadirPregunta() {
    const pregunta: pregunta = {
      pregunta: "",
      imagen: "",
      opciones: [],
      correctas: [],
    }
    this.examen = this.examen.concat(pregunta)
  }

  eliminarPregunta(pregIndex) {
    this.examen.splice(pregIndex, 1);
  }

  anadirOpcion(pregIndex) {
    const numero = this.examen[pregIndex].opciones.length
    const opcion: opcion = {
      texto: "",
      numero: numero
    }
    this.examen[pregIndex].opciones = this.examen[pregIndex].opciones.concat(opcion);
  }

  checkCorrecta(pregIndex, event) {
    if (event.target.checked) {
      this.anadirCorrecta(pregIndex, event.target.value);
    } else {
      this.eliminarCorrecta(pregIndex, event.target.value);
    }
  }

  anadirCorrecta(pregIndex, optIndex) {
    this.examen[pregIndex].correctas.push(+optIndex);
    this.examen[pregIndex].correctas = this.examen[pregIndex].correctas.sort((a, b) => a - b)
  }

  eliminarCorrecta(pregIndex, optIndex) {
    const index = this.examen[pregIndex].correctas.findIndex(x => x == optIndex);
    this.examen[pregIndex].correctas.splice(index, 1);
    if (this.examen[pregIndex].correctas.length > 0) {
      this.examen[pregIndex].correctas = this.examen[pregIndex].correctas.sort((a, b) => a - b)
    }
  }

  eliminarOpcion(pregIndex, optIndex) {
    this.examen[pregIndex].opciones.splice(optIndex, 1);
    if (this.examen[pregIndex].opciones.length > 0) {
      for (let i = optIndex; i < this.examen[pregIndex].opciones.length; i++) {
        this.examen[pregIndex].opciones[i].numero -= 1;
      }
      if (this.examen[pregIndex].correctas.includes(optIndex)) {
        this.eliminarCorrecta(pregIndex, optIndex);
      }
      for (let i = 0; i < this.examen[pregIndex].correctas.length; i++) {
        if (this.examen[pregIndex].correctas[i] > optIndex) {
          this.examen[pregIndex].correctas[i] -= 1;
        }
      }
    }
  }

  anadirImagen(event, pregIndex) {
    const file = event.target.files[0];
    let nombre: string = file.name;
    nombre = nombre.replace(' ','-');
    const filePath = `Examen/${this.id}/${nombre}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(`Examen/${this.id}/${nombre}`, file);
    task
      .snapshotChanges().pipe(
        finalize(() => {
          this.downloadURL = fileRef.getDownloadURL();
          this.downloadURL.subscribe(url => {
            if (url) {
              this.examen[pregIndex].imagen = url
            }
          });
        })
      ).subscribe(url => {
        if (url) {
          console.log(url);
        }
      });
  }

  checkOpcionCorrecta(pregIndex, optIndex) {
    if (this.examen[pregIndex].correctas.includes(optIndex)) {
      return true;
    } else {
      return false;
    }
  }

  guardarExamen() {
    this.afs.collection("examen").doc(this.id).set({
      preguntas: this.examen
    }).then(() => {
      this.afs.collection("sesionesVisitante").doc(this.id).update({
        examenPreguntas: this.examen.length,
      })
      this.dialogService.dialogExito().afterClosed().subscribe(res => {
        return null
      })
    }).catch(error => {
      this.dialogService.dialogFracaso()
      console.log(error)
    });
  }
}
